import { type CacheState } from '@/app-state/models/cache/state';
import { type Action } from '@rematch/core';

const fetchDataReducer = (state: CacheState[keyof CacheState], action: Action) => {
  switch (action.type) {
    case 'FETCH_INIT':
      return {
        ...state,
        isLoading: true,
        hasError: false,
        data: {},
      };
    case 'FETCH_SUCCESS':
      return {
        ...state,
        isLoading: false,
        hasError: false,
        data: action.payload,
      };
    case 'FETCH_FAIL':
      return {
        ...state,
        isLoading: false,
        hasError: true,
      };
    default:
      throw new Error(`Unknown action type`);
  }
};

export { fetchDataReducer };
